/** @jsx jsx */
import { jsx } from '@emotion/core'
import { VFlow } from 'bold-ui'
import { resolveName } from 'components/form'
import { getFormGroupErrors } from 'components/form/final-form/util'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { useForm } from 'react-final-form'
import { useFieldArray } from 'react-final-form-arrays'
import { toDate } from 'util/date/formatDate'
import { MetaRoot } from 'util/metaPath'
import { isObjectDeepFalsy } from 'util/object'

import { AnexoArquivoFormModel } from '../../model-anexoArquivos'
import { ExameAccordion } from './ExameAccordion'
import { ExameSolicitadoSelect } from './ExameSolicitadoSelect'

interface ExamesSolicitadosFormProps {
  name: MetaRoot<AnexoArquivoFormModel>
}

export function ExamesSolicitadosForm(props: Readonly<ExamesSolicitadosFormProps>) {
  const { name } = props

  const {
    fields: { push, remove, value },
  } = useFieldArray(resolveName(name.resultadosComSolicitacao), { subscription: { value: true } })

  const {
    cidadao: { dataNascimento },
    atendimentoProfissional: { iniciadoEm },
  } = useAtendimentoContext()

  const formApi = useForm()

  return (
    <VFlow>
      <ExameSolicitadoSelect onChange={push} />
      {value?.filterNotNull().map((item, idx) => {
        const { dataRealizado, dataSolicitacao } = item
        const dataRealizadoAsDate = toDate(dataRealizado)
        const dataSolicitadoAsDate = toDate(dataSolicitacao)

        const error = !isObjectDeepFalsy(getFormGroupErrors(name.resultadosComSolicitacao?.[idx], formApi))
        const errorIgnoringTouchedAndDirty = !isObjectDeepFalsy(
          getFormGroupErrors(name.resultadosComSolicitacao?.[idx], formApi, true)
        )

        return (
          <ExameAccordion
            key={item.id}
            name={name.resultadosComSolicitacao?.[idx]}
            remove={() => remove(idx)}
            value={item}
            dataInicioAtendimento={iniciadoEm}
            dataRealizado={dataRealizadoAsDate}
            dataSolicitado={dataSolicitadoAsDate}
            dataNascimento={toDate(dataNascimento)}
            errors={{ allErrors: error, ignoringTouchedAndDirtyErrors: errorIgnoringTouchedAndDirty }}
            isSolicitado
          />
        )
      })}
    </VFlow>
  )
}
